export default __webpack_public_path__ + "static/media/teamwork.f9f4ff96.svg";